import { CurveType } from "../constants/maps";

export type MarkData = {
  key: string;
  name: string;
  markCoordinates: [number, number];
};

export type CurveVariant = {
  curveType: CurveType;
  curveCoordinates: [number, number][];
  markData: MarkData[];
};

export type SaturationCurve = {
  id: string;
  color: string;
  secondaryColor: string;
  nodeUUID: string;
  brand: string;
  channel: string;
  channelLabel: string;
  product: string;
  category: string;
  geography: string | null;
  curveTypes: Record<CurveType, CurveVariant>;
  activeWeeks: number;
  rating: Rating | null;
  revenue: number;
  spend: number;
  confidence: number;
  lowerBound: number;
  upperBound: number;
  curveValue: number;
  maxEfficiency: number;
  roi: number;
  roas: number;
  units: number;
};

export type SaturationCurveKeyPoints = {
  currentSpend: [number, number];
  maxEfficiency: [number, number];
  lowerThreshold: [number, number];
  upperThreshold: [number, number];
};

export enum Rating {
  Negative = "neg",
  Neutral = "neu",
  Positive = "pos",
}
